import React from 'react'
import Footer from './components/footer'
import PDF from  './img/kiviArticleFeb2020.pdf'

function PressRelease(){
	return(
		<><section class="intro-single">
		<div class="container">
		  <div class="row">
			<div class="col-md-12 col-lg-12">
			  <div class="title-single-box">
				<h1 class="title-single">Press Release</h1>
			 

			  </div>
            
              <div className="text-center"> 
              <object data={PDF} className="pdf-responsive">
<p>Your web browser doesn't have a PDF Plugin. Instead you can <a href={PDF}> Click
here to download the PDF</a></p>
</object></div>
			 
			</div> </div>
			</div> </section>
	 <Footer/></>
)
	}
	
export default PressRelease